/** Distancia mínima (px) hacia el cierre para recoger el panel. */
export const OVERLAY_NAV_DISMISS_MIN_PX = 56;

/** |dx| debe superar |dy| en este factor para no pelear con el scroll vertical. */
export const OVERLAY_NAV_DISMISS_AXIS_RATIO = 1.15;

export function overlayNavDragTranslateX(dx: number, rtl: boolean): number {
  return rtl ? Math.max(0, dx) : Math.min(0, dx);
}

export function shouldDismissOverlayNav(dx: number, dy: number, rtl: boolean): boolean {
  const towardClose = rtl ? dx > 0 : dx < 0;
  if (!towardClose) {
    return false;
  }
  const absX = Math.abs(dx);
  const absY = Math.abs(dy);
  if (absX < OVERLAY_NAV_DISMISS_MIN_PX) {
    return false;
  }
  return absX >= absY * OVERLAY_NAV_DISMISS_AXIS_RATIO;
}

export function isOverlayNavOutsideTarget(target: EventTarget | null, drawerSelector = '.mat-drawer.sidebarNav'): boolean {
  if (!(target instanceof Element)) {
    return false;
  }
  if (target.closest('[data-overlay-nav-toggle]')) {
    return false;
  }
  if (target.closest(drawerSelector)) {
    return false;
  }
  if (target.closest('.cdk-overlay-pane, .mat-mdc-dialog-container, .mat-bottom-sheet-container')) {
    return false;
  }
  return true;
}
